import * as React from "react";
import Modal from "../ModalWindow/Modal";
import {CSSProperties} from "react";
import styles from "./InfoIcon.module.scss";

const InfoIcon: React.FC<{style?: CSSProperties; children: React.ReactNode}> = (props) => {
  const [open, setOpen] = React.useState<boolean>(false);

  return (
    <span style={props.style} className={`${styles.wrapper} Svg Svg-Icon-Info`} onClick={() => setOpen(true)}>
      <Modal isVisible={open} closeFunction={() => setOpen(false)}>
        {props.children}
      </Modal>
    </span>
  );
};

export default InfoIcon;
